<template>
  <div class="admin-wrapper">
    <el-row class="rowStyle">
      <el-date-picker v-model="startDate" type="date" placeholder="Start Date" class="datePicker">
      </el-date-picker>
      <el-date-picker v-model="endDate" type="date" placeholder="End Date" class="datePicker">
      </el-date-picker>
      <el-button type="primary" v-on:click="getMetrics">Go</el-button>
    </el-row>
    <!-- bregin cards-->
    <el-row class="rowStyle">
      <el-col :span="12">
        <!-- Legacy Monthly Subscribers card -->
        <el-card class="box-card">
          <div slot="header" class="clearfix">
            <span>Legacy Monthly Subscribers</span>
          </div>
          <div>
            <el-row class="rowStyle">
              <el-col :span="12" class="cellStyle"
                ><div>Alpha Monthly Users</div></el-col
              >
              <el-col :span="12" class="cellStyle"
                ><div>{{ totalCurrentAlphaMonthlyUsers }}</div></el-col
              >
            </el-row>
            <!-- Metric Entry -->
            <el-row class="rowStyle">
              <el-col :span="12" class="cellStyle"
                ><div>Beta Monthly Users</div></el-col
              >
              <el-col :span="12" class="cellStyle"
                ><div>{{ totalCurrentBetaMonthlyUsers }}</div></el-col
              >
            </el-row>
            <!-- Metric Entry -->
            <el-row class="rowStyle">
              <el-col :span="12" class="cellStyle"
                ><div>Gamma Monthly Users</div></el-col
              >
              <el-col :span="12" class="cellStyle"
                ><div>{{ totalCurrentGammaMonthlyUsers }}</div></el-col
              >
            </el-row>
            <!-- Metric Entry -->
            <el-row class="rowStyle">
              <el-col :span="12" class="cellStyle"
                ><div>Pro Monthly Users</div></el-col
              >
              <el-col :span="12" class="cellStyle"
                ><div>{{ totalCurrentProMonthlyUsers }}</div></el-col
              >
            </el-row>
          </div>
        </el-card>
      </el-col>
      <el-col :span="12">
        <!-- Legacy Annual Subscribers card -->
        <el-card class="box-card">
          <div slot="header" class="clearfix">
            <span>Legacy Annual Subscribers</span>
          </div>
          <div>
            <!-- Metric Entry -->
            <el-row class="rowStyle">
              <el-col :span="12" class="cellStyle"
                ><div>Alpha Annual Users</div></el-col
              >
              <el-col :span="12" class="cellStyle"
                ><div>{{ totalCurrentAlphaAnnualUsers }}</div></el-col
              >
            </el-row>
            <!-- Metric Entry -->
            <el-row class="rowStyle">
              <el-col :span="12" class="cellStyle"
                ><div>Beta Annual Users</div></el-col
              >
              <el-col :span="12" class="cellStyle"
                ><div>{{ totalCurrentBetaAnnualUsers }}</div></el-col
              >
            </el-row>
            <!-- Metric Entry -->
            <el-row class="rowStyle">
              <el-col :span="12" class="cellStyle"
                ><div>Gamma Annual Users</div></el-col
              >
              <el-col :span="12" class="cellStyle"
                ><div>{{ totalCurrentGammaAnnualUsers }}</div></el-col
              >
            </el-row>
            <!-- Metric Entry -->
            <el-row class="rowStyle">
              <el-col :span="12" class="cellStyle"
                ><div>Pro Annual Users</div></el-col
              >
              <el-col :span="12" class="cellStyle"
                ><div>{{ totalCurrentProAnnualUsers }}</div></el-col
              >
            </el-row>
          </div></el-card
        ></el-col
      >
    </el-row>
    <el-row class="rowStyle">
      <el-col :span="12">
        <!-- Current Subscribed Monthly Users -->
        <el-card class="box-card">
          <div slot="header" class="clearfix">
            <span>Subscribed Monthly Users</span>
          </div>
          <div>
            <!-- Metric Entry -->
            <el-row class="rowStyle">
              <el-col :span="12" class="cellStyle"
                ><div>Creator Monthly Users</div></el-col
              >
              <el-col :span="12" class="cellStyle"
                ><div>{{ totalCurrentCreatorMonthlyUsers }}</div></el-col
              >
            </el-row>
            <!-- Metric Entry -->
            <el-row class="rowStyle">
              <el-col :span="12" class="cellStyle"
                ><div>Influencer Monthly Users</div></el-col
              >
              <el-col :span="12" class="cellStyle"
                ><div>{{ totalCurrentInfluencerMonthlyUsers }}</div></el-col
              >
            </el-row>
            <!-- Metric Entry -->
            <el-row class="rowStyle">
              <el-col :span="12" class="cellStyle"
                ><div>Agency Monthly Users</div></el-col
              >
              <el-col :span="12" class="cellStyle"
                ><div>{{ totalCurrentAgencyMonthlyUsers }}</div></el-col
              >
            </el-row>
            <!-- Metric Entry -->
            <el-row class="rowStyle">
              <el-col :span="12" class="cellStyle"
                ><div>Network Monthly Users</div></el-col
              >
              <el-col :span="12" class="cellStyle"
                ><div>{{ totalCurrentNetworkMonthlyUsers }}</div></el-col
              >
            </el-row>
          </div></el-card
        ></el-col
      >
      <el-col :span="12">
        <!-- Current Subscribed Annual Users -->
        <el-card class="box-card">
          <div slot="header" class="clearfix">
            <span>Subscribed Annual Users</span>
          </div>
          <div>
            <!-- Metric Entry -->
            <el-row class="rowStyle">
              <el-col :span="12" class="cellStyle"
                ><div>Creator Annual Users</div></el-col
              >
              <el-col :span="12" class="cellStyle"
                ><div>{{ totalCurrentCreatorAnnualUsers }}</div></el-col
              >
            </el-row>
            <!-- Metric Entry -->
            <el-row class="rowStyle">
              <el-col :span="12" class="cellStyle"
                ><div>Influencer Annual Users</div></el-col
              >
              <el-col :span="12" class="cellStyle"
                ><div>{{ totalCurrentInfluencerAnnualUsers }}</div></el-col
              >
            </el-row>
            <!-- Metric Entry -->
            <el-row class="rowStyle">
              <el-col :span="12" class="cellStyle"
                ><div>Agency Annual Users</div></el-col
              >
              <el-col :span="12" class="cellStyle"
                ><div>{{ totalCurrentAgencyAnnualUsers }}</div></el-col
              >
            </el-row>
            <!-- Metric Entry -->
            <el-row class="rowStyle">
              <el-col :span="12" class="cellStyle"
                ><div>Network Annual Users</div></el-col
              >
              <el-col :span="12" class="cellStyle"
                ><div>{{ totalCurrentNetworkAnnualUsers }}</div></el-col
              >
            </el-row>
          </div></el-card
        ></el-col
      >
    </el-row>
    <el-row class="rowStyle">
      <el-col :span="12">
        <!-- Total Videos Made By Subscription -->
        <el-card class="box-card">
          <div slot="header" class="clearfix">
            <span>Total Videos Made By...</span>
          </div>
          <div>
            <!-- Metric Entry -->
            <el-row class="rowStyle">
              <el-col :span="12" class="cellStyle"
                ><div>Alpha Users</div></el-col
              >
              <el-col :span="12" class="cellStyle"
                ><div>{{ totalVideosMageByAlphaUsers }}</div></el-col
              >
            </el-row>
            <!-- Metric Entry -->
            <el-row class="rowStyle">
              <el-col :span="12" class="cellStyle"
                ><div>Beta Users</div></el-col
              >
              <el-col :span="12" class="cellStyle"
                ><div>{{ totalVideosMageByBetaUsers }}</div></el-col
              >
            </el-row>
            <!-- Metric Entry -->
            <el-row class="rowStyle">
              <el-col :span="12" class="cellStyle"
                ><div>Gamma Users</div></el-col
              >
              <el-col :span="12" class="cellStyle"
                ><div>{{ totalVideosMadeByGammaUsers }}</div></el-col
              >
            </el-row>
            <!-- Metric Entry -->
            <el-row class="rowStyle">
              <el-col :span="12" class="cellStyle"
                ><div>Pro Users</div></el-col
              >
              <el-col :span="12" class="cellStyle"
                ><div>{{ totalVideosMadeByProUsers }}</div></el-col
              >
            </el-row>
            <!-- Metric Entry -->
            <el-row class="rowStyle">
              <el-col :span="12" class="cellStyle"
                ><div>Creator Users</div></el-col
              >
              <el-col :span="12" class="cellStyle"
                ><div>{{ totalVideosMageByCreatorUsers }}</div></el-col
              >
            </el-row>
            <!-- Metric Entry -->
            <el-row class="rowStyle">
              <el-col :span="12" class="cellStyle"
                ><div>Influencer Users</div></el-col
              >
              <el-col :span="12" class="cellStyle"
                ><div>{{ totalVideosMadeeByInfluencerUsers }}</div></el-col
              >
            </el-row>
            <!-- Metric Entry -->
            <el-row class="rowStyle">
              <el-col :span="12" class="cellStyle"
                ><div>Agency Users</div></el-col
              >
              <el-col :span="12" class="cellStyle"
                ><div>{{ totalVideosMadeeByAgencyUsers }}</div></el-col
              >
            </el-row>
            <!-- Metric Entry -->
            <el-row class="rowStyle">
              <el-col :span="12" class="cellStyle"
                ><div>Network Users</div></el-col
              >
              <el-col :span="12" class="cellStyle"
                ><div>{{ totalVideosMadeeByNetworkUsers }}</div></el-col
              >
            </el-row>
          </div></el-card
        ></el-col
      >
      <el-col :span="12">
        <!-- Average Videos Made By Subscription -->
        <el-card class="box-card">
          <div slot="header" class="clearfix">
            <span>Average Number of Videos Made By...</span>
          </div>
          <div>
            <!-- Metric Entry -->
            <el-row class="rowStyle">
              <el-col :span="12" class="cellStyle"
                ><div>Alpha Users</div></el-col
              >
              <el-col :span="12" class="cellStyle"
                ><div>{{ averageVideosMadeForAlphaUsers }}</div></el-col
              >
            </el-row>
            <!-- Metric Entry -->
            <el-row class="rowStyle">
              <el-col :span="12" class="cellStyle"
                ><div>Beta Users</div></el-col
              >
              <el-col :span="12" class="cellStyle"
                ><div>{{ averageVideosMadeForBetaUsers }}</div></el-col
              >
            </el-row>
            <!-- Metric Entry -->
            <el-row class="rowStyle">
              <el-col :span="12" class="cellStyle"
                ><div>Gamma Users</div></el-col
              >
              <el-col :span="12" class="cellStyle"
                ><div>{{ averageVideosMadeForGammaUsers }}</div></el-col
              >
            </el-row>
            <!-- Metric Entry -->
            <el-row class="rowStyle">
              <el-col :span="12" class="cellStyle"
                ><div>Pro Users</div></el-col
              >
              <el-col :span="12" class="cellStyle"
                ><div>{{ averageVideosMadeForProUsers }}</div></el-col
              >
            </el-row>
            <!-- Metric Entry -->
            <el-row class="rowStyle">
              <el-col :span="12" class="cellStyle"
                ><div>Influencer Users</div></el-col
              >
              <el-col :span="12" class="cellStyle"
                ><div>{{ averageVideosMadeForInfluencerUsers }}</div></el-col
              >
            </el-row>
            <!-- Metric Entry -->
            <el-row class="rowStyle">
              <el-col :span="12" class="cellStyle"
                ><div>Creator Users</div></el-col
              >
              <el-col :span="12" class="cellStyle"
                ><div>{{ averageVideosMadeForCreatorUsers }}</div></el-col
              >
            </el-row>
            <!-- Metric Entry -->
            <el-row class="rowStyle">
              <el-col :span="12" class="cellStyle"
                ><div>Agency Users</div></el-col
              >
              <el-col :span="12" class="cellStyle"
                ><div>{{ averageVideosMadeForAgencyUsers }}</div></el-col
              >
            </el-row>
            <!-- Metric Entry -->
            <el-row class="rowStyle">
              <el-col :span="12" class="cellStyle"
                ><div>Network Users</div></el-col
              >
              <el-col :span="12" class="cellStyle"
                ><div>{{ averageVideosMadeForNetworkUsers }}</div></el-col
              >
            </el-row>
          </div></el-card
        ></el-col
      >
    </el-row>
    <el-row class="rowStyle">
      <el-col :span="12">
        <!-- Average Length Of Videos for Alpha Users -->
        <el-card class="box-card">
          <div slot="header" class="clearfix">
            <span>Average Length Of Videos Made by...</span>
          </div>
          <div>
            <!-- Metric Entry -->
            <el-row class="rowStyle">
              <el-col :span="12" class="cellStyle"
                ><div>Alpha Users</div></el-col
              >
              <el-col :span="12" class="cellStyle"
                ><div>
                  {{ (averageLengthOfVideosMadeForAlphaUsers / 60).toFixed(0) }}:{{
                    (averageLengthOfVideosMadeForAlphaUsers % 60).toFixed(0)
                  }}
                  Min:Sec
                </div></el-col
              >
            </el-row>
            <!-- Metric Entry -->
            <el-row class="rowStyle">
              <el-col :span="12" class="cellStyle"
                ><div>Betta Users</div></el-col
              >
              <el-col :span="12" class="cellStyle"
                ><div>
                  {{ (averageLengthOfVideosMadeForBetaUsers / 60).toFixed(0) }}:{{
                    (averageLengthOfVideosMadeForBetaUsers % 60).toFixed(0)
                  }}
                  Min:Sec
                </div></el-col
              >
            </el-row>
            <!-- Metric Entry -->
            <el-row class="rowStyle">
              <el-col :span="12" class="cellStyle"
                ><div>Gamma Users</div></el-col
              >
              <el-col :span="12" class="cellStyle"
                ><div>
                  {{ (averageLengthOfVideosMadeForGammaUsers / 60).toFixed(0) }}:{{
                    (averageLengthOfVideosMadeForGammaUsers % 60).toFixed(0)
                  }}
                  Min:Sec
                </div></el-col
              >
            </el-row>
            <!-- Metric Entry -->
            <el-row class="rowStyle">
              <el-col :span="12" class="cellStyle"
                ><div>Pro Users</div></el-col
              >
              <el-col :span="12" class="cellStyle"
                ><div>
                  {{ (averageLengthOfVideosMadeForProUsers / 60).toFixed(0) }}:{{
                    (averageLengthOfVideosMadeForProUsers % 60).toFixed(0)
                  }}
                  Min:Sec
                </div></el-col
              >
            </el-row>
              <!-- Metric Entry -->
            <el-row class="rowStyle">
              <el-col :span="12" class="cellStyle"
                ><div>Creator Users</div></el-col
              >
              <el-col :span="12" class="cellStyle"
                ><div>
                  {{ (averageLengthOfVideosMadeForCreatorUsers / 60).toFixed(0) }}:{{
                    (averageLengthOfVideosMadeForCreatorUsers % 60).toFixed(0)
                  }}
                  Min:Sec
                </div></el-col
              >
            </el-row>
                        <!-- Metric Entry -->
            <el-row class="rowStyle">
              <el-col :span="12" class="cellStyle"
                ><div>Influencer Users</div></el-col
              >
              <el-col :span="12" class="cellStyle"
                ><div>
                  {{ (averageLengthOfVideosMadeForInfluencerUsers / 60).toFixed(0) }}:{{
                    (averageLengthOfVideosMadeForInfluencerUsers % 60).toFixed(0)
                  }}
                  Min:Sec
                </div></el-col
              >
            </el-row>
                        <!-- Metric Entry -->
            <el-row class="rowStyle">
              <el-col :span="12" class="cellStyle"
                ><div>Agency Users</div></el-col
              >
              <el-col :span="12" class="cellStyle"
                ><div>
                  {{ (averageLengthOfVideosMadeForAgencyUsers / 60).toFixed(0) }}:{{
                    (averageLengthOfVideosMadeForAgencyUsers % 60).toFixed(0)
                  }}
                  Min:Sec
                </div></el-col
              >
            </el-row>
                        <!-- Metric Entry -->
            <el-row class="rowStyle">
              <el-col :span="12" class="cellStyle"
                ><div>Network Users</div></el-col
              >
              <el-col :span="12" class="cellStyle"
                ><div>
                  {{ (averageLengthOfVideosMadeForNetworkUsers / 60).toFixed(0) }}:{{
                    (averageLengthOfVideosMadeForNetworkUsers % 60).toFixed(0)
                  }}
                  Min:Sec
                </div></el-col
              >
            </el-row>
          </div></el-card
        ></el-col
      >
      <el-col :span="12">
        <!-- Other KPIs -->
        <el-card class="box-card">
          <div slot="header" class="clearfix">
            <span>Other KPIs</span>
          </div>
          <div>
            <!-- Metric Entry -->
            <el-row class="rowStyle">
              <el-col :span="12" class="cellStyle"><div>Average Time To First Video</div></el-col>
              <el-col :span="12" class="cellStyle"
                ><div>
                  {{ (averageTimeToFirstVideo / 60).toFixed(0) }}:{{
                    (averageTimeToFirstVideo % 60).toFixed(0)
                  }}
                  Min:Sec
                </div></el-col
              >
            </el-row>
            <!-- Metric Entry -->
            <el-row class="rowStyle">
              <el-col :span="12" class="cellStyle"><div>Total Subs Paused</div></el-col>
              <el-col :span="12" class="cellStyle"
                ><div>{{ totalPauses }}</div></el-col
              >
            </el-row>
            <!-- Metric Entry -->
            <el-row class="rowStyle">
              <el-col :span="12" class="cellStyle"><div>Total Subs Canceled</div></el-col>
              <el-col :span="12" class="cellStyle"
                ><div>{{ totalCancels }}</div></el-col
              >
            </el-row>
            <!-- Metric Entry -->
            <el-row class="rowStyle">
              <el-col :span="12" class="cellStyle"
                ><div>
                  Pause to Cancel Conversions
                </div></el-col
              >
              <el-col :span="12" class="cellStyle"
                ><div>{{ pausesConvertedToCancels }}</div></el-col
              >
            </el-row>
          </div></el-card
        ></el-col
      >
    </el-row>
    <!-- end cards -->
  </div>
</template>

<script>
import axios from "axios";

export default {
  name: "metrics",
  data() {
    return {
      totalCurrentAlphaMonthlyUsers: "-", //--
      totalCurrentBetaMonthlyUsers: "-", //--
      totalCurrentGammaMonthlyUsers: "-", //--
      totalCurrentAlphaAnnualUsers: "-", //--
      totalCurrentBetaAnnualUsers: "-", //--
      totalCurrentGammaAnnualUsers: "-", //--
      totalCurrentProMonthlyUsers: "-", //--
      totalCurrentProAnnualUsers: "-", //--
      averageVideosMadeForAlphaUsers: "-", //--
      averageVideosMadeForBetaUsers: "-", //--
      averageVideosMadeForGammaUsers: "-", //--
      averageVideosMadeForProUsers: "-", //--
      averageVideosMadeForInfluencerUsers: "-",
      averageVideosMadeForCreatorUsers: "-",
      averageVideosMadeForAgencyUsers: "-",
      averageVideosMadeForNetworkUsers: "-",
      averageLengthOfVideosMadeForAlphaUsers: "-", //--
      averageLengthOfVideosMadeForBetaUsers: "-", //--
      averageLengthOfVideosMadeForGammaUsers: "-", //--
      averageLengthOfVideosMadeForProUsers: "-", //--
      averageLengthOfVideosMadeForCreatorUsers: "-", //--
      averageLengthOfVideosMadeForInfluencerUsers: "-", //--
      averageLengthOfVideosMadeForAgencyUsers: "-", //--
      averageLengthOfVideosMadeForNetworkUsers: "-", //--
      averageTimeToFirstVideo: "-", //--
      totalVideosMageByAlphaUsers: "-", //--
      totalVideosMageByBetaUsers: "-", //--
      totalVideosMadeByGammaUsers: "-", //--
      totalVideosMadeByProUsers: "-", //--
      totalPauses: "-", //--
      totalCancels: "-", //--
      pausesConvertedToCancels: "-", //--
      totalCurrentInfluencerMonthlyUsers: "-", //--
      totalCurrentCreatorMonthlyUsers: "-", //--
      totalCurrentAgencyMonthlyUsers: "-", //--
      totalCurrentNetworkMonthlyUsers: "-", //--
      totalCurrentCreatorAnnualUsers: "-", //--
      totalCurrentInfluencerAnnualUsers: "-", //--
      totalCurrentAgencyAnnualUsers: "-", //--
      totalCurrentNetworkAnnualUsers: "-", //--
      totalVideosMageByCreatorUsers: "-", //--
      totalVideosMadeeByInfluencerUsers: "-", //--
      totalVideosMadeeByAgencyUsers: "-", //--
      totalVideosMadeeByNetworkUsers: "-", //--
      startDate: "",
      endDate: "",
      activeMetric: ["1"],
      apiURL: `${this.$store.state.apiEndpoint}/api/metrics`
    };
  },
  methods: {
    getMetrics() {
      this.resetMetrics();
      this.getTotalAlphaMonthlyUsers();
      this.getTotalBetaMonthlyUsers();
      this.getTotalGammaMonthlyUsers();
      this.getTotalProMonthlyUsers();
      this.getTotalCurrentAlphaAnnualUsers();
      this.getTotalCurrentBetaAnnualUsers();
      this.getTotalCurrentGammaAnnualUsers();
      this.getTotalCurrentProAnnualUsers();
      this.getTotalCurrentCreatorMonthlyUsers();
      this.getTotalCurrentInfluencerMonthlyUsers();
      this.getTotalCurrentAgencyMonthlyUsers();
      this.getTotalCurrentNetworkMonthlyUsers();
      this.getTotalCurrentCreatorAnnualUsers();
      this.getTotalCurrentInfluencerAnnualUsers();
      this.getTotalCurrentAgencyAnnualUsers();
      this.getTotalCurrentNetworkAnnualUsers();
      this.getTotalVideosMadeByAlphaUsers();
      this.getTotalVideosMadeByBetaUsers();
      this.getTotalVideosMadeByGammaUsers();
      this.getTotalVideosMadeByProUsers();
      this.getTotalVideosMadeByCreatorUsers();
      this.getTotalVideosMadeeByInfluencerUsers();
      this.getTotalVideosMadeeByAgencyUsers();
      this.getTotalVideosMadeeByNetworkUsers();
      this.getAverageVideosMadeForAlphaUsers();
      this.getAverageVideosMadeForBetaUsers();
      this.getAverageVideosMadeForGammaUsers();
      this.getAverageVideosMadeForProUsers();
      this.getAverageVideosMadeForInfluencerUsers();
      this.getAverageVideosMadeForCreatorUsers();
      this.getAverageVideosMadeForAgencyUsers();
      this.getAverageVideosMadeForNetworkUsers();
      this.getAverageLengthOfVideosMadeForAlphaUsers();
      this.getAverageLengthOfVideosMadeForBetaUsers();
      this.getAverageLengthOfVideosMadeForGammaUsers();
      this.getAverageLengthOfVideosMadeForProUsers();
      this.getAverageLengthOfVideosMadeCreatorUsers();
      this.getAverageLengthOfVideosMadeForInfluencerUsers();
      this.getAverageLengthOfVideosMadeForAgencyUsers();
      this.getAverageLengthOfVideosMadeForNetworkUsers();
      this.getAverageTimeToFirstVideo();
      this.getTotalPauses();
      this.getTotalCancels();
      this.getPausesConvertedToCancels();
    },
    resetMetrics() {
      this.totalCurrentAlphaMonthlyUsers = '-';
      this.totalCurrentBetaMonthlyUsers= '-';
      this.totalCurrentGammaMonthlyUsers = '-';
      this.totalCurrentAlphaAnnualUsers = '-';
      this.totalCurrentBetaAnnualUsers = '-';
      this.totalCurrentGammaAnnualUsers = '-';
      this.totalCurrentProMonthlyUsers = '-';
      this.totalCurrentProAnnualUsers = '-';
      this.averageVideosMadeForAlphaUsers = '-';
      this.averageVideosMadeForBetaUsers = '-';
      this.averageVideosMadeForGammaUsers = '-';
      this.averageVideosMadeForProUsers = '-';
      this.averageVideosMadeForInfluencerUsers = '-';
      this.averageVideosMadeForCreatorUsers = '-';
      this.averageVideosMadeForAgencyUsers = '-';
      this.averageVideosMadeForNetworkUsers = '-';
      this.averageLengthOfVideosMadeForAlphaUsers = '-';
      this.averageLengthOfVideosMadeForBetaUsers = '-';
      this.averageLengthOfVideosMadeForGammaUsers = '-';
      this.averageLengthOfVideosMadeForProUsers = '-';
      this.averageLengthOfVideosMadeForCreatorUsers = '-';
      this.averageLengthOfVideosMadeForInfluencerUsers = '-';
      this.averageLengthOfVideosMadeForAgencyUsers = '-';
      this.averageLengthOfVideosMadeForNetworkUsers = '-';
      this.averageTimeToFirstVideo = '-';
      this.totalVideosMageByAlphaUsers = '-';
      this.totalVideosMageByBetaUsers = '-';
      this.totalVideosMadeByGammaUsers = '-';
      this.totalVideosMadeByProUsers = '-';
      this.totalPauses = '-';
      this.totalCancels = '-';
      this.pausesConvertedToCancels = '-';
      this.totalCurrentInfluencerMonthlyUsers = '-';
      this.totalCurrentCreatorMonthlyUsers = '-';
      this.totalCurrentAgencyMonthlyUsers = '-';
      this.totalCurrentNetworkMonthlyUsers = '-';
      this.totalCurrentCreatorAnnualUsers = '-';
      this.totalCurrentInfluencerAnnualUsers = '-';
      this.totalCurrentAgencyAnnualUsers = '-';
      this.totalCurrentNetworkAnnualUsers = '-';
      this.totalVideosMageByCreatorUsers = '-';
      this.totalVideosMadeeByInfluencerUsers = '-';
      this.totalVideosMadeeByAgencyUsers = '-';
      this.totalVideosMadeeByNetworkUsers = '-';
    },
    async getTotalAlphaMonthlyUsers() {
      const url = this.apiURL.concat("/getTotalCurrentAlphaMonthlyUsers");
      this.totalCurrentAlphaMonthlyUsers = await axios.post(url, {
        end: Date.parse(this.endDate),
        start: Date.parse(this.startDate)
      });
    },
    async getTotalBetaMonthlyUsers() {
      const url = this.apiURL.concat("/getTotalCurrentBetaMonthlyUsers");
      this.totalCurrentBetaMonthlyUsers = await axios.post(url, {
        end: Date.parse(this.endDate),
        start: Date.parse(this.startDate)
      });
    },
    async getTotalGammaMonthlyUsers() {
      const url = this.apiURL.concat("/getTotalCurrentGammaMonthlyUsers");
      this.totalCurrentGammaMonthlyUsers = await axios.post(url, {
        end: Date.parse(this.endDate),
        start: Date.parse(this.startDate)
      });
    },
    async getTotalProMonthlyUsers() {
      const url = this.apiURL.concat("/getTotalCurrentProMonthlyUsers");
      this.totalCurrentProMonthlyUsers = await axios.post(url, {
        end: Date.parse(this.endDate),
        start: Date.parse(this.startDate)
      });
    },
    async getTotalCurrentAlphaAnnualUsers() {
      const url = this.apiURL.concat("/getTotalCurrentAlphaAnnualUsers");
      this.totalCurrentAlphaAnnualUsers = await axios.post(url, {
        end: Date.parse(this.endDate),
        start: Date.parse(this.startDate)
      });
    },
    async getTotalCurrentBetaAnnualUsers() {
      const url = this.apiURL.concat("/getTotalCurrentBetaAnnualUsers");
      this.totalCurrentBetaAnnualUsers = await axios.post(url, {
        end: Date.parse(this.endDate),
        start: Date.parse(this.startDate)
      });
    },
    async getTotalCurrentGammaAnnualUsers() {
      const url = this.apiURL.concat("/getTotalCurrentGammaAnnualUsers");
      this.totalCurrentGammaAnnualUsers = await axios.post(url, {
        end: Date.parse(this.endDate),
        start: Date.parse(this.startDate)
      });
    },
    async getTotalCurrentProAnnualUsers() {
      const url = this.apiURL.concat("/getTotalCurrentProAnnualUsers");
      this.totalCurrentProAnnualUsers = await axios.post(url, {
        end: Date.parse(this.endDate),
        start: Date.parse(this.startDate)
      });
    },
    async getTotalCurrentCreatorMonthlyUsers() {
      const url = this.apiURL.concat("/getTotalCurrentCreatorMonthlyUsers");
      this.totalCurrentCreatorMonthlyUsers = await axios.post(url, {
        end: Date.parse(this.endDate),
        start: Date.parse(this.startDate)
      });
    },
    async getTotalCurrentInfluencerMonthlyUsers() {
      const url = this.apiURL.concat("/getTotalCurrentInfluencerMonthlyUsers");
      this.totalCurrentInfluencerMonthlyUsers = await axios.post(url, {
        end: Date.parse(this.endDate),
        start: Date.parse(this.startDate)
      });
    },
    async getTotalCurrentAgencyMonthlyUsers() {
      const url = this.apiURL.concat("/getTotalCurrentAgencyMonthlyUsers");
      this.totalCurrentAgencyMonthlyUsers = await axios.post(url, {
        end: Date.parse(this.endDate),
        start: Date.parse(this.startDate)
      });
    },
    async getTotalCurrentNetworkMonthlyUsers() {
      const url = this.apiURL.concat("/getTotalCurrentNetworkMonthlyUsers");
      this.totalCurrentNetworkMonthlyUsers = await axios.post(url, {
        end: Date.parse(this.endDate),
        start: Date.parse(this.startDate)
      });
    },
    async getTotalCurrentCreatorAnnualUsers() {
      const url = this.apiURL.concat("/getTotalCurrentCreatorAnnualUsers");
      this.totalCurrentCreatorAnnualUsers = await axios.post(url, {
        end: Date.parse(this.endDate),
        start: Date.parse(this.startDate)
      });
    },
    async getTotalCurrentInfluencerAnnualUsers() {
      const url = this.apiURL.concat("/getTotalCurrentInfluencerAnnualUsers");
      this.totalCurrentInfluencerAnnualUsers = await axios.post(url, {
        end: Date.parse(this.endDate),
        start: Date.parse(this.startDate)
      });
    },

    async getTotalCurrentAgencyAnnualUsers() {
      const url = this.apiURL.concat("/getTotalCurrentAgencyAnnualUsers");
      this.totalCurrentAgencyAnnualUsers = await axios.post(url, {
        end: Date.parse(this.endDate),
        start: Date.parse(this.startDate)
      });
    },
    async getTotalCurrentNetworkAnnualUsers() {
      const url = this.apiURL.concat("/getTotalCurrentNetworkAnnualUsers");
      this.totalCurrentNetworkAnnualUsers = await axios.post(url, {
        end: Date.parse(this.endDate),
        start: Date.parse(this.startDate)
      });
    },
    async getTotalVideosMadeByAlphaUsers() {
      const url = this.apiURL.concat("/getTotalVideosMageByAlphaUsers");
      this.totalVideosMageByAlphaUsers = await axios.post(url, {
        end: Date.parse(this.endDate),
        start: Date.parse(this.startDate)
      });
    },
    async getTotalVideosMadeByBetaUsers() {
      const url = this.apiURL.concat("/getTotalVideosMageByBetaUsers");
      this.totalVideosMageByBetaUsers = await axios.post(url, {
        end: Date.parse(this.endDate),
        start: Date.parse(this.startDate)
      });
    },
    async getTotalVideosMadeByGammaUsers() {
      const url = this.apiURL.concat("/getTotalVideosMadeByGammaUsers");
      this.totalVideosMadeByGammaUsers = await axios.post(url, {
        end: Date.parse(this.endDate),
        start: Date.parse(this.startDate)
      });
    },
    async getTotalVideosMadeByProUsers() {
      const url = this.apiURL.concat("/getTotalVideosMadeByProUsers");
      this.totalVideosMadeByProUsers = await axios.post(url, {
        end: Date.parse(this.endDate),
        start: Date.parse(this.startDate)
      });
    },
    async getTotalVideosMadeByCreatorUsers() {
      const url = this.apiURL.concat("/getTotalVideosMageByCreatorUsers");
      this.totalVideosMageByCreatorUsers = await axios.post(url, {
        end: Date.parse(this.endDate),
        start: Date.parse(this.startDate)
      });
    },
    async getTotalVideosMadeeByInfluencerUsers() {
      const url = this.apiURL.concat("/getTotalVideosMadeeByInfluencerUsers");
      this.totalVideosMadeeByInfluencerUsers = await axios.post(url, {
        end: Date.parse(this.endDate),
        start: Date.parse(this.startDate)
      });
    },
    async getTotalVideosMadeeByAgencyUsers() {
      const url = this.apiURL.concat("/getTotalVideosMadeeByAgencyUsers");
      this.totalVideosMadeeByAgencyUsers = await axios.post(url, {
        end: Date.parse(this.endDate),
        start: Date.parse(this.startDate)
      });
    },
    async getTotalVideosMadeeByNetworkUsers() {
      const url = this.apiURL.concat("/getTotalVideosMadeeByNetworkUsers");
      this.totalVideosMadeeByNetworkUsers = await axios.post(url, {
        end: Date.parse(this.endDate),
        start: Date.parse(this.startDate)
      });
    },
    async getAverageVideosMadeForAlphaUsers() {
      const url = this.apiURL.concat("/getAverageVideosMadeForAlphaUsers");
      this.averageVideosMadeForAlphaUsers = await axios.post(url, {
        end: Date.parse(this.endDate),
        start: Date.parse(this.startDate)
      });
    },
    async getAverageVideosMadeForBetaUsers() {
      const url = this.apiURL.concat("/getAverageVideosMadeForBetaUsers");
      this.averageVideosMadeForBetaUsers = await axios.post(url, {
        end: Date.parse(this.endDate),
        start: Date.parse(this.startDate)
      });
    },
    async getAverageVideosMadeForGammaUsers() {
      const url = this.apiURL.concat("/getAverageVideosMadeGammaUsers");
      this.averageVideosMadeForGammaUsers = await axios.post(url, {
        end: Date.parse(this.endDate),
        start: Date.parse(this.startDate)
      });
    },
    async getAverageVideosMadeForProUsers() {
      const url = this.apiURL.concat("/getAverageVideosMadeForProUsers");
      this.averageVideosMadeForProUsers = await axios.post(url, {
        end: Date.parse(this.endDate),
        start: Date.parse(this.startDate)
      });
    },




    async getAverageVideosMadeForInfluencerUsers() {
      const url = this.apiURL.concat("/getAverageVideosMadeForInfluencerUsers");
      this.averageVideosMadeForInfluencerUsers = await axios.post(url, {
        end: Date.parse(this.endDate),
        start: Date.parse(this.startDate)
      });
    },
    async getAverageVideosMadeForCreatorUsers() {
      const url = this.apiURL.concat("/getAverageVideosMadeForCreatorUsers");
      this.averageVideosMadeForCreatorUsers = await axios.post(url, {
        end: Date.parse(this.endDate),
        start: Date.parse(this.startDate)
      });
    },
    async getAverageVideosMadeForAgencyUsers() {
      const url = this.apiURL.concat("/getAverageVideosMadeForAgencyUsers");
      this.averageVideosMadeForAgencyUsers = await axios.post(url, {
        end: Date.parse(this.endDate),
        start: Date.parse(this.startDate)
      });
    },
    async getAverageVideosMadeForNetworkUsers() {
      const url = this.apiURL.concat("/getAverageVideosMadeForNetworkUsers");
      this.averageVideosMadeForNetworkUsers = await axios.post(url, {
        end: Date.parse(this.endDate),
        start: Date.parse(this.startDate)
      });
    },




    async getAverageLengthOfVideosMadeForAlphaUsers() {
      const url = this.apiURL.concat("/getAverageVideoLengthForAlphaUsers");
      this.averageLengthOfVideosMadeForAlphaUsers = await axios.post(url, {
        end: Date.parse(this.endDate),
        start: Date.parse(this.startDate)
      });
    },
    async getAverageLengthOfVideosMadeForBetaUsers() {
      const url = this.apiURL.concat("/getAverageVideoLengthForBetaUsers");
      this.averageLengthOfVideosMadeForBetaUsers = await axios.post(url, {
        end: Date.parse(this.endDate),
        start: Date.parse(this.startDate)
      });
    },
    async getAverageLengthOfVideosMadeForGammaUsers() {
      const url = this.apiURL.concat("/getAverageVideoLengthForGammaUsers");
      this.averageLengthOfVideosMadeForGammaUsers = await axios.post(url, {
        end: Date.parse(this.endDate),
        start: Date.parse(this.startDate)
      });
    },
    async getAverageLengthOfVideosMadeForProUsers() {
      const url = this.apiURL.concat("/getAverageVideoLengthForProUsers");
      this.averageLengthOfVideosMadeForProUsers = await axios.post(url, {
        end: Date.parse(this.endDate),
        start: Date.parse(this.startDate)
      });
    },


    async getAverageLengthOfVideosMadeCreatorUsers() {
      const url = this.apiURL.concat("/getAverageVideoLengthForCreatorUsers");
      this.averageLengthOfVideosMadeForCreatorUsers = await axios.post(url, {
        end: Date.parse(this.endDate),
        start: Date.parse(this.startDate)
      });
    },    async getAverageLengthOfVideosMadeForInfluencerUsers() {
      const url = this.apiURL.concat("/getAverageVideoLengthForInfluencerUsers");
      this.averageLengthOfVideosMadeForInfluencerUsers = await axios.post(url, {
        end: Date.parse(this.endDate),
        start: Date.parse(this.startDate)
      });
    },    async getAverageLengthOfVideosMadeForAgencyUsers() {
      const url = this.apiURL.concat("/getAverageVideoLengthForAgencyUsers");
      this.averageLengthOfVideosMadeForAgencyUsers = await axios.post(url, {
        end: Date.parse(this.endDate),
        start: Date.parse(this.startDate)
      });
    },    async getAverageLengthOfVideosMadeForNetworkUsers() {
      const url = this.apiURL.concat("/getAverageVideoLengthForNetworkUsers");
      this.averageLengthOfVideosMadeForNetworkUsers = await axios.post(url, {
        end: Date.parse(this.endDate),
        start: Date.parse(this.startDate)
      });
    },




    async getAverageTimeToFirstVideo() {
      const url = this.apiURL.concat("/getAverageTimeToFirstVideo");
      this.averageTimeToFirstVideo = await axios.post(url, {
        end: Date.parse(this.endDate),
        start: Date.parse(this.startDate)
      });
    },
    async getTotalPauses() {
      const url = this.apiURL.concat("/getTotalPauses");
      this.totalPauses = await axios.post(url, {
        end: Date.parse(this.endDate),
        start: Date.parse(this.startDate)
      });
    },
    async getTotalCancels() {
      const url = this.apiURL.concat("/getTotalCancels");
      this.totalCancels = await axios.post(url, {
        end: Date.parse(this.endDate),
        start: Date.parse(this.startDate)
      });
    },
    async getPausesConvertedToCancels() {
      const url = this.apiURL.concat("/getPausesConvertedToCancels");
      this.pausesConvertedToCancels = await axios.post(url, {
        end: Date.parse(this.endDate),
        start: Date.parse(this.startDate)
      });
    }
  }
};
</script>

<style scoped>
.cellStyle {
  border-bottom: 1px solid black;
}
.box-card {
  margin: 10px 10px 10px 10px;
}
.rowStyle {
  margin: 5px 5px 5px 5px;
}
.rowHeader {
  font-size: 28px;
  margin: 15px 25px 15px 15px;
  font-display: bold;
}
.datePicker {
  margin: 5px 15px 5px 15px;
}
</style>
